export type SizeOption = {
  id: string;
  label: string;
  width: number;
  height: number;
  orientation: "square" | "portrait" | "landscape" | string;
  recommended?: boolean;
  recommendedFor: string[];
};

export type PlacementInfo = {
  fromCollar: string;
  horizontal: string;
  notes: string;
};

export type LocationOption = {
  id: string;
  label: string;
  placementType: "chest" | "front" | "back" | "sleeve" | "label" | string;
  placements: PlacementInfo;
  warnings?: string[];
  sizes: SizeOption[];
};

export type GarmentOption = {
  id: string;
  label: string;
  category: "adult" | "youth" | string;
  locations: LocationOption[];
};

export type ArtworkSizingData = {
  garments: GarmentOption[];
};

export function findGarment(
  data: ArtworkSizingData,
  garmentId: string
): GarmentOption | null {
  return data.garments.find((g) => g.id === garmentId) || null;
}

export function findLocation(
  garment: GarmentOption | null,
  locationId: string
): LocationOption | null {
  if (!garment) return null;
  return garment.locations.find((location) => location.id === locationId) || null;
}

export function getRecommendedSize(sizes: SizeOption[]): SizeOption | null {
  if (!sizes.length) return null;

  const explicitlyRecommended = sizes.find((size) => size.recommended === true);
  if (explicitlyRecommended) return explicitlyRecommended;

  return sizes[0] || null;
}

export function getLocationsForGarment(
  data: ArtworkSizingData,
  garmentId: string
): LocationOption[] {
  const garment = findGarment(data, garmentId);
  return garment?.locations || [];
}

export function getDefaultLocationForGarment(
  data: ArtworkSizingData,
  garmentId: string
): LocationOption | null {
  const garment = findGarment(data, garmentId);
  return garment?.locations?.[0] || null;
}

export function getPlacementWarnings(location: LocationOption | null): string[] {
  if (!location?.warnings?.length) return [];
  return location.warnings;
}